import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../auth";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);
  const { refresh } = useAuth();
  const nav = useNavigate();
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    const poll = async (attempt) => {
      if (cancelled) return;
      if (attempt >= 8) {
        setStatus("timeout");
        return;
      }
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("success");
          await refresh();
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
        setAttempts(attempt + 1);
        setTimeout(() => poll(attempt + 1), 2000);
      } catch (_e) {
        setTimeout(() => poll(attempt + 1), 2000);
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "var(--auprea-cream)" }}>
      <div className="auprea-card max-w-lg w-full text-center">
        {status === "checking" && (
          <>
            <div style={{ fontSize: 14, color: "var(--auprea-gold)", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: 12 }}>Vérification…</div>
            <h2 style={{ fontSize: 26 }}>Confirmation de votre paiement</h2>
            <p style={{ marginTop: 12, color: "rgba(35,38,46,0.7)" }}>Tentative {attempts + 1}/8 — patientez quelques secondes.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 size={56} color="#2f7d5b" style={{ margin: "0 auto 16px" }} />
            <h2 style={{ fontSize: 28 }}>Paiement confirmé</h2>
            <p style={{ marginTop: 12, color: "rgba(35,38,46,0.7)", lineHeight: 1.6 }}>
              Bienvenue dans votre nouveau forfait. Toutes les rubriques sont maintenant accessibles.
            </p>
            <button className="auprea-btn mt-6" onClick={() => nav("/carnet/identite")} data-testid="btn-success-continue">
              Accéder à mon carnet
            </button>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <AlertCircle size={56} color="#b53a3a" style={{ margin: "0 auto 16px" }} />
            <h2 style={{ fontSize: 26 }}>Paiement non confirmé</h2>
            <p style={{ marginTop: 12, color: "rgba(35,38,46,0.7)" }}>Vous pouvez réessayer ou nous contacter.</p>
            <button className="auprea-btn-outline mt-6" onClick={() => nav("/tarifs")}>Revenir aux tarifs</button>
          </>
        )}
      </div>
    </div>
  );
}
